module.exports = __webpack_public_path__ + "static/img/dialog-bg-1.523d4a42.png";